import { render, staticRenderFns } from "./GapRadioGroup.vue?vue&type=template&id=8a644af6&scoped=true"
import script from "./GapRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./GapRadioGroup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GapRadioGroup.vue?vue&type=style&index=0&id=8a644af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a644af6",
  null
  
)

export default component.exports